import { Icon, IconProps } from "./Icon";

export function IconElevator(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M22.63 24H1.36A1.37 1.37 0 0 1 0 22.63V1.37A1.36 1.36 0 0 1 1.36 0h21.27A1.37 1.37 0 0 1 24 1.37v21.26A1.37 1.37 0 0 1 22.63 24ZM1.36 1a.37.37 0 0 0-.36.37v21.26a.36.36 0 0 0 .36.36h21.27a.37.37 0 0 0 .37-.37V1.37a.36.36 0 0 0-.37-.37Zm19.6 8.87L17 5.5l-3.98 4.37.74.67 2.74-3v10.97h1V7.54l2.72 3 .74-.67zM7.5 16.48V5.5h-1v10.98l-2.72-3.01-.74.68L7 18.51l3.97-4.36-.74-.68-2.73 3.01z" />
    </Icon>
  );
}
